var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.852,11.25 L18.824,11.306 L18.852,11.306 L18.852,12.426 C18.852,12.5753341 18.8240003,12.7199993 18.768,12.86 L16.99,16.962 C16.915333,17.1766677 16.780001,17.3493327 16.584,17.48 C16.387999,17.6106673 16.1686679,17.676 15.926,17.676 L10.676,17.676 C10.3586651,17.676 10.0833345,17.5593345 9.85,17.326 C9.6166655,17.0926655 9.5,16.8173349 9.5,16.5 L9.5,10.676 C9.5,10.3773318 9.6166655,10.1020013 9.85,9.85 L13.686,6 L14.316,6.63 C14.4746675,6.78866746 14.554,6.98933212 14.554,7.232 L14.554,7.428 L13.98,10.102 L17.676,10.102 C17.9933349,10.102 18.2686655,10.2139989 18.502,10.438 C18.7353345,10.6620011 18.852,10.9326651 18.852,11.25 Z M6,17.676 L6,10.676 L8.352,10.676 L8.352,17.676 L6,17.676 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.6ddb41d2faf26ab94c7d66eb701fa1a0.svg";
export { ForwardRef as ReactComponent };